export interface TranslationKeys {
  common: {
    save: string;
    cancel: string;
    delete: string;
    edit: string;
    loading: string;
    error: string;
    success: string;
    confirm: string;
    back: string;
    next: string;
    done: string;
    search: string;
    noResults: string;
    viewAll: string;
    seeMore: string;
    close: string;
    retry: string;
    share: string;
    copy: string;
    signOut: string;
    or: string;
    and: string;
    yes: string;
    no: string;
    optional: string;
    required: string;
    submit: string;
    update: string;
    create: string;
    add: string;
    remove: string;
    filter: string;
    sort: string;
    all: string;
    none: string;
    select: string;
    selected: string;
    showing: string;
    of: string;
    to: string;
    from: string;
  };
  nav: {
    dashboard: string;
    feed: string;
    workout: string;
    templates: string;
    leaderboard: string;
    analytics: string;
    achievements: string;
    premium: string;
    friends: string;
    profile: string;
    notifications: string;
    settings: string;
    support: string;
    logout: string;
    more: string;
    newWorkout: string;
    home: string;
    admin: string;
  };
  auth: {
    welcome: string;
    signIn: string;
    signUp: string;
    signInDescription: string;
    signUpDescription: string;
    signInOrCreateAccount: string;
    email: string;
    password: string;
    username: string;
    usernamePlaceholder: string;
    passwordPlaceholder: string;
    forgotPassword: string;
    resetPassword: string;
    resetPasswordDesc: string;
    resetPasswordDescription: string;
    sendResetLink: string;
    setNewPassword: string;
    confirmPassword: string;
    confirmNewPassword: string;
    confirmNewPasswordBtn: string;
    confirmYourPassword: string;
    newPassword: string;
    enterNewPassword: string;
    enterNewPasswordBelow: string;
    createAccount: string;
    alreadyHaveAccount: string;
    dontHaveAccount: string;
    signingIn: string;
    creatingAccount: string;
    sending: string;
    updating: string;
    passwordRequirements: string;
    passwordHint: string;
    emailVerified: string;
    emailVerifiedDesc: string;
    checkEmail: string;
    checkYourEmail: string;
    resetLinkSent: string;
    failedToSendReset: string;
    accountCreated: string;
    welcomeMessage: string;
    welcomeToFitlink: string;
    loginFailed: string;
    signupFailed: string;
    usernameTaken: string;
    passwordsDontMatch: string;
    passwordsDontMatchDesc: string;
    passwordUpdated: string;
    passwordUpdatedDesc: string;
    passwordRequirementsNotMet: string;
    missingCredentials: string;
    enterEmail: string;
    enterPassword: string;
    accountLocked: string;
    tooManyAttempts: string;
    tryAgainLater: string;
    serviceUnavailable: string;
    serviceUnavailableDesc: string;
    privacyNotice: string;
    privacyDescription: string;
    dataCollection: string;
    dataPrivacy: string;
    dataPrivacyDesc: string;
    agreeToTerms: string;
    termsAndPrivacy: string;
    termsOfUse: string;
    privacyPolicy: string;
    stayFitStayLinked: string;
    verificationEmailSent: string;
    tagline: string;
    fullName: string;
  };
  settings: {
    title: string;
    description: string;
    appearance: string;
    darkMode: string;
    lightMode: string;
    themeDescription: string;
    language: string;
    languageDescription: string;
    saveReload: string;
    profileManagement: string;
    personalInfo: string;
    personalInfoDescription: string;
    editPersonalInfo: string;
    goalsExperience: string;
    goalsDescription: string;
    updateGoals: string;
    subscription: string;
    manageSubscription: string;
    updatePayment: string;
    legalPrivacy: string;
    legalDescription: string;
    termsOfUse: string;
    privacyPolicy: string;
    dangerZone: string;
    dangerDescription: string;
    resetStatistics: string;
    deleteAccount: string;
    resetConfirmTitle: string;
    resetConfirmDescription: string;
    resetConfirmList: {
      workouts: string;
      exercises: string;
      prs: string;
      achievements: string;
      streaks: string;
    };
    resetConfirmWarning: string;
    resetButton: string;
    resetting: string;
    deleteConfirmTitle: string;
    deleteWarning: string;
    deleteConfirmList: {
      workouts: string;
      achievements: string;
      friends: string;
      photos: string;
      profile: string;
      subscription: string;
    };
    typeDelete: string;
    deleting: string;
    deleteButton: string;
  };
  toast: {
    saved: string;
    deleted: string;
    error: string;
    copied: string;
    signedOut: string;
    workoutDeleted: string;
    workoutSaved: string;
    templateSaved: string;
    templateDeleted: string;
    preferencesUpdated: string;
    friendRequestSent: string;
    friendRequestAccepted: string;
    profileUpdated: string;
  };
  workout: {
    title: string;
    startWorkout: string;
    finishWorkout: string;
    saveWorkout: string;
    addExercise: string;
    sets: string;
    reps: string;
    weight: string;
    notes: string;
    rest: string;
    noExercises: string;
    duration: string;
    calories: string;
    description: string;
    private: string;
    public: string;
    trackDuration: string;
    manualDuration: string;
    exercisePlaceholder: string;
    saveAsTemplate: string;
    loadTemplate: string;
    doAgain: string;
    analyze: string;
    deleteConfirm: string;
    deleteConfirmDescription: string;
    kg: string;
    lbs: string;
    minutes: string;
    hours: string;
    seconds: string;
    set: string;
    exercise: string;
    exercises: string;
    completed: string;
    inProgress: string;
    paused: string;
    resume: string;
    pause: string;
    stop: string;
    restTimer: string;
    skipRest: string;
    addSet: string;
    removeSet: string;
    superset: string;
    createSuperset: string;
    personalRecord: string;
    newPR: string;
    previousBest: string;
    selectExercise: string;
    searchExercises: string;
    recentExercises: string;
    allExercises: string;
    customExercise: string;
    addCustomExercise: string;
    targetMuscles: string;
    techniqueTips: string;
    commonMistakes: string;
    history: string;
    noHistory: string;
    tagFriends: string;
    shareWorkout: string;
    copyWorkout: string;
    workoutComplete: string;
    greatJob: string;
    summary: string;
    totalVolume: string;
    totalSets: string;
    totalReps: string;
  };
  dashboard: {
    title: string;
    welcome: string;
    todayWorkout: string;
    weeklyProgress: string;
    recentActivity: string;
    quickActions: string;
    noWorkouts: string;
    startFirst: string;
    pullToRefresh: string;
    loadMore: string;
    communityFeed: string;
    yourFeed: string;
    announcements: string;
    noActivity: string;
    startWorking: string;
    streak: string;
    days: string;
    thisWeek: string;
    personalRecords: string;
    weeklyGoal: string;
    workoutsThisWeek: string;
    activity: string;
    upgradeToPremium: string;
    unlockFeatures: string;
    beFirstToLog: string;
    logFirstWorkout: string;
    doLiveWorkout: string;
    editWorkout: string;
    moreExercises: string;
    showLess: string;
    aiWorkoutAnalysis: string;
    aiAnalysisDescription: string;
    loadingMore: string;
    endOfFeed: string;
    workoutTitle: string;
    workoutTitlePlaceholder: string;
    descriptionPlaceholder: string;
    saveChanges: string;
    withFriends: string;
  };
  profile: {
    title: string;
    editProfile: string;
    followers: string;
    following: string;
    workouts: string;
    joined: string;
    yourGoals: string;
    fitnessGoal: string;
    experienceLevel: string;
    weeklyCheckIn: string;
    workoutHistory: string;
    checkIns: string;
    upgradePremium: string;
    unlockFeatures: string;
    viewPlans: string;
    bio: string;
    fullName: string;
    dateOfBirth: string;
    height: string;
    currentWeight: string;
    gender: string;
    male: string;
    female: string;
    other: string;
    preferNotToSay: string;
    saveChanges: string;
    noGoalsSet: string;
    setGoals: string;
    memberSince: string;
    totalWorkouts: string;
    currentStreak: string;
    longestStreak: string;
    verified: string;
    statisticsReset: string;
    statisticsResetDesc: string;
    resetFailed: string;
    goalsUpdated: string;
    goalsUpdatedDesc: string;
    goals: {
      buildMuscle: string;
      loseWeight: string;
      getStronger: string;
      improveEndurance: string;
      stayActive: string;
      athleticPerformance: string;
    };
  };
  achievements: {
    title: string;
    unlocked: string;
    locked: string;
    progress: string;
    keepGoing: string;
    newUnlock: string;
    milestone: string;
    strength: string;
    consistency: string;
    social: string;
    variety: string;
    volume: string;
    all: string;
    earned: string;
    unearned: string;
    congratulations: string;
    youEarned: string;
    shareAchievement: string;
    viewAll: string;
    recentlyUnlocked: string;
  };
  friends: {
    title: string;
    addFriend: string;
    searchUsers: string;
    pending: string;
    accepted: string;
    noFriends: string;
    sendRequest: string;
    acceptRequest: string;
    declineRequest: string;
    removeFriend: string;
    friendRequests: string;
    myFriends: string;
    suggestions: string;
    noRequests: string;
    requestSent: string;
    requestAccepted: string;
    requestDeclined: string;
    friendRemoved: string;
    mutualFriends: string;
    viewProfile: string;
    message: string;
  };
  premium: {
    title: string;
    upgrade: string;
    features: string;
    monthly: string;
    yearly: string;
    currentPlan: string;
    subscribe: string;
    restore: string;
    perMonth: string;
    perYear: string;
    savePercent: string;
    mostPopular: string;
    freePlan: string;
    premiumPlan: string;
    includesFeatures: string;
    unlockAll: string;
    alreadyPremium: string;
    manageSubscription: string;
    cancelAnytime: string;
    startFreeTrial: string;
    trialDays: string;
    bestValue: string;
    billedAnnually: string;
    billedMonthly: string;
    featuresList: {
      analytics: string;
      leaderboard: string;
      aiAnalysis: string;
      templates: string;
      checkIns: string;
      exportData: string;
      prioritySupport: string;
      noAds: string;
    };
  };
  templates: {
    title: string;
    create: string;
    edit: string;
    delete: string;
    myTemplates: string;
    publicTemplates: string;
    noTemplates: string;
    createFirst: string;
    templateName: string;
    templateDescription: string;
    category: string;
    makePublic: string;
    publicDescription: string;
    addExercise: string;
    saveTemplate: string;
    useTemplate: string;
    startWorkout: string;
    exercises: string;
    createdBy: string;
    generateWithAI: string;
    aiPromptPlaceholder: string;
    generating: string;
    categories: {
      all: string;
      beginner: string;
      advanced: string;
      strength: string;
      hypertrophy: string;
      endurance: string;
      general: string;
    };
  };
  analytics: {
    title: string;
    overview: string;
    volume: string;
    strength: string;
    progression: string;
    calendar: string;
    period: string;
    week: string;
    month: string;
    year: string;
    totalWorkouts: string;
    totalVolume: string;
    avgVolume: string;
    personalRecords: string;
    muscleGroups: string;
    volumeOverTime: string;
    strengthProgress: string;
    workoutCalendar: string;
    noData: string;
    startTracking: string;
    comparedToPrevious: string;
    improvement: string;
    decline: string;
    noChange: string;
    exerciseTrends: string;
    plateauDetection: string;
    injuryRisk: string;
    fitnessScore: string;
    restDays: string;
    prRate: string;
    bestDay: string;
    volumeVelocity: string;
    filters: {
      muscleGroup: string;
      exerciseType: string;
      all: string;
      chest: string;
      back: string;
      legs: string;
      shoulders: string;
      arms: string;
      cardio: string;
      strength: string;
    };
  };
  notifications: {
    title: string;
    markAllRead: string;
    deleteAll: string;
    noNotifications: string;
    preferences: string;
    types: {
      like: string;
      comment: string;
      friendRequest: string;
      friendAccepted: string;
      personalRecord: string;
      workoutTag: string;
      announcement: string;
    };
    settings: {
      likes: string;
      likesDescription: string;
      comments: string;
      commentsDescription: string;
      friendRequests: string;
      friendRequestsDescription: string;
      friendAccepted: string;
      friendAcceptedDescription: string;
      personalRecords: string;
      personalRecordsDescription: string;
      workoutTags: string;
      workoutTagsDescription: string;
    };
    deleteAllConfirm: string;
    deleteAllDescription: string;
    allMarkedRead: string;
    allDeleted: string;
  };
  support: {
    title: string;
    contactUs: string;
    contactDescription: string;
    emailSupport: string;
    responseTime: string;
    submitTicket: string;
    faq: string;
    frequentlyAsked: string;
    privacyPolicy: string;
    privacyDescription: string;
    accountDeletion: string;
    accountDeletionDescription: string;
    goToSettings: string;
    faqs: {
      cancelSubscription: {
        question: string;
        answer: string;
      };
      deleteAccount: {
        question: string;
        answer: string;
      };
      dataAfterDeletion: {
        question: string;
        answer: string;
      };
      restorePurchase: {
        question: string;
        answer: string;
      };
      exportData: {
        question: string;
        answer: string;
      };
    };
  };
  leaderboard: {
    title: string;
    rank: string;
    user: string;
    score: string;
    fitnessScore: string;
    weeklyVolume: string;
    monthlyWorkouts: string;
    totalPRs: string;
    yourRank: string;
    top10: string;
    friends: string;
    friendsRanking: string;
    global: string;
    globalRanking: string;
    noData: string;
    period: string;
    metric: string;
  };
  time: {
    justNow: string;
    minutesAgo: string;
    hoursAgo: string;
    daysAgo: string;
    weeksAgo: string;
    monthsAgo: string;
    yearsAgo: string;
    today: string;
    yesterday: string;
    thisWeek: string;
    lastWeek: string;
    thisMonth: string;
    lastMonth: string;
  };
  errors: {
    somethingWentWrong: string;
    tryAgain: string;
    networkError: string;
    notFound: string;
    unauthorized: string;
    forbidden: string;
    serverError: string;
    validationError: string;
    requiredField: string;
    invalidEmail: string;
    invalidPassword: string;
    passwordTooShort: string;
    usernameTaken: string;
    emailTaken: string;
    invalidCredentials: string;
    sessionExpired: string;
    rateLimited: string;
    serviceUnavailable: string;
  };
  landing: {
    hero: string;
    tagline: string;
    getStarted: string;
    learnMore: string;
    features: {
      trackProgress: {
        title: string;
        description: string;
      };
      socialFeed: {
        title: string;
        description: string;
      };
      achieveGoals: {
        title: string;
        description: string;
      };
    };
  };
}

export const en: TranslationKeys = {
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    done: "Done",
    search: "Search",
    noResults: "No results found",
    viewAll: "View All",
    seeMore: "See More",
    close: "Close",
    retry: "Retry",
    share: "Share",
    copy: "Copy",
    signOut: "Sign Out",
    or: "or",
    and: "and",
    yes: "Yes",
    no: "No",
    optional: "Optional",
    required: "Required",
    submit: "Submit",
    update: "Update",
    create: "Create",
    add: "Add",
    remove: "Remove",
    filter: "Filter",
    sort: "Sort",
    all: "All",
    none: "None",
    select: "Select",
    selected: "selected",
    showing: "Showing",
    of: "of",
    to: "to",
    from: "from",
  },
  nav: {
    dashboard: "Dashboard",
    feed: "Feed",
    workout: "Workout",
    templates: "Templates",
    leaderboard: "Leaderboard",
    analytics: "Analytics",
    achievements: "Achievements",
    premium: "Premium",
    friends: "Friends",
    profile: "Profile",
    notifications: "Notifications",
    settings: "Settings",
    support: "Support",
    logout: "Logout",
    more: "More",
    newWorkout: "New Workout",
    home: "Home",
    admin: "Admin",
  },
  auth: {
    welcome: "Welcome",
    signIn: "Sign In",
    signUp: "Sign Up",
    signInDescription: "Sign in to your account",
    signUpDescription: "Create a new account to get started",
    signInOrCreateAccount: "Sign in or create an account to get started",
    email: "Email",
    password: "Password",
    username: "Username",
    usernamePlaceholder: "your_username",
    passwordPlaceholder: "At least 12 characters",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    resetPasswordDesc: "Enter your email address and we'll send you a link to reset your password.",
    resetPasswordDescription: "Enter your email address and we'll send you a link to reset your password.",
    sendResetLink: "Send Reset Link",
    setNewPassword: "Set New Password",
    confirmPassword: "Confirm Password",
    confirmNewPassword: "Confirm New Password",
    confirmNewPasswordBtn: "Confirm New Password",
    confirmYourPassword: "Confirm your new password",
    newPassword: "New Password",
    enterNewPassword: "Enter your new password",
    enterNewPasswordBelow: "Enter your new password below",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    signingIn: "Signing in...",
    creatingAccount: "Creating account...",
    sending: "Sending...",
    updating: "Updating...",
    passwordRequirements: "Must contain at least 12 characters, including uppercase, lowercase, number, and special character",
    passwordHint: "Must include uppercase, lowercase, number, and special character",
    emailVerified: "Email Verified!",
    emailVerifiedDesc: "Your email has been verified successfully.",
    checkEmail: "Check your email for the verification link",
    checkYourEmail: "Check Your Email!",
    resetLinkSent: "We've sent you a password reset link. Please check your email.",
    failedToSendReset: "Failed to send password reset email",
    accountCreated: "Account Created!",
    welcomeMessage: "Welcome to FITLINK! Let's get you started.",
    welcomeToFitlink: "Welcome to FITLINK! Let's get you started.",
    loginFailed: "Login Failed",
    signupFailed: "Signup Failed",
    usernameTaken: "This username is already taken. Please choose a different one.",
    passwordsDontMatch: "Passwords Don't Match",
    passwordsDontMatchDesc: "Please make sure both passwords match.",
    passwordUpdated: "Password Updated!",
    passwordUpdatedDesc: "Your password has been successfully reset.",
    passwordRequirementsNotMet: "Password Requirements Not Met",
    missingCredentials: "Missing credentials",
    enterEmail: "Please enter your email",
    enterPassword: "Please enter your password",
    accountLocked: "Account Temporarily Locked",
    tooManyAttempts: "Too Many Attempts",
    tryAgainLater: "Please try again later.",
    serviceUnavailable: "Service Temporarily Unavailable",
    serviceUnavailableDesc: "Unable to verify rate limits. Please try again in a moment.",
    privacyNotice: "Privacy Notice",
    privacyDescription: "We collect your workout data to provide personalized fitness tracking and recommendations.",
    dataCollection: "Data we collect",
    dataPrivacy: "Data Privacy",
    dataPrivacyDesc: "We collect your workout data, profile information, and usage analytics to provide personalized fitness tracking. Your data is encrypted and never sold.",
    agreeToTerms: "By signing up, you agree to our",
    termsAndPrivacy: "Terms of Service and Privacy Policy",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    stayFitStayLinked: "Stay fit, stay linked.",
    tagline: "Stay fit, stay linked.",
    verificationEmailSent: "We've sent you a verification email. Please check your inbox and click the link to verify your account.",
    fullName: "Full Name",
  },
  settings: {
    title: "Settings",
    description: "Manage your app preferences and data",
    appearance: "Appearance",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    themeDescription: "Toggle between light and dark themes",
    language: "Language",
    languageDescription: "Choose your preferred language",
    saveReload: "Save & Reload",
    profileManagement: "Profile Management",
    personalInfo: "Personal Information",
    personalInfoDescription: "Update your personal details to help AI recommendations",
    editPersonalInfo: "Edit Personal Info",
    goalsExperience: "Goals & Experience",
    goalsDescription: "Update your fitness goals and experience level",
    updateGoals: "Update Goals",
    subscription: "Subscription",
    manageSubscription: "Manage Subscription",
    updatePayment: "Update payment or cancel plan",
    legalPrivacy: "Legal & Privacy",
    legalDescription: "Review our policies and terms",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    dangerZone: "Danger Zone",
    dangerDescription: "Permanently delete all your workout data, PRs, achievements, and statistics",
    resetStatistics: "Reset All Statistics",
    deleteAccount: "Delete Account",
    resetConfirmTitle: "Reset All Statistics?",
    resetConfirmDescription: "This action cannot be undone. This will permanently delete:",
    resetConfirmList: {
      workouts: "All your workout history",
      exercises: "All exercise records",
      prs: "All personal records (PRs)",
      achievements: "All achievements and badges",
      streaks: "All workout streaks",
    },
    resetConfirmWarning: "Are you absolutely sure you want to continue?",
    resetButton: "Yes, Reset Everything",
    resetting: "Resetting...",
    deleteConfirmTitle: "Delete Account Permanently?",
    deleteWarning: "This action is PERMANENT and CANNOT be undone!",
    deleteConfirmList: {
      workouts: "All workouts and exercise history",
      achievements: "All achievements and personal records",
      friends: "All friends and social connections",
      photos: "All photos and check-in data",
      profile: "Your profile and account information",
      subscription: "Your subscription (if active)",
    },
    typeDelete: "Type DELETE to confirm:",
    deleting: "Deleting...",
    deleteButton: "Delete Account Permanently",
  },
  toast: {
    saved: "Changes saved successfully",
    deleted: "Deleted successfully",
    error: "Something went wrong",
    copied: "Copied to clipboard",
    signedOut: "Signed out successfully",
    workoutDeleted: "Workout deleted",
    workoutSaved: "Workout saved successfully",
    templateSaved: "Template saved!",
    templateDeleted: "Template deleted",
    preferencesUpdated: "Preferences updated",
    friendRequestSent: "Friend request sent",
    friendRequestAccepted: "Friend request accepted!",
    profileUpdated: "Profile updated successfully",
  },
  workout: {
    title: "Workout",
    startWorkout: "Start Workout",
    finishWorkout: "Finish Workout",
    saveWorkout: "Save Workout",
    addExercise: "Add Exercise",
    sets: "Sets",
    reps: "Reps",
    weight: "Weight",
    notes: "Notes",
    rest: "Rest",
    noExercises: "No exercises added yet",
    duration: "Duration",
    calories: "Calories",
    description: "Description",
    private: "Private",
    public: "Public",
    trackDuration: "Track Duration",
    manualDuration: "Manual Duration",
    exercisePlaceholder: "Add your first exercise to get started",
    saveAsTemplate: "Save as Template",
    loadTemplate: "Load Template",
    doAgain: "Do Again",
    analyze: "AI Analysis",
    deleteConfirm: "Delete Workout?",
    deleteConfirmDescription: "This action cannot be undone.",
    kg: "kg",
    lbs: "lbs",
    minutes: "minutes",
    hours: "hours",
    seconds: "seconds",
    set: "Set",
    exercise: "Exercise",
    exercises: "Exercises",
    completed: "Completed",
    inProgress: "In Progress",
    paused: "Paused",
    resume: "Resume",
    pause: "Pause",
    stop: "Stop",
    restTimer: "Rest Timer",
    skipRest: "Skip Rest",
    addSet: "Add Set",
    removeSet: "Remove Set",
    superset: "Superset",
    createSuperset: "Create Superset",
    personalRecord: "Personal Record",
    newPR: "New PR!",
    previousBest: "Previous Best",
    selectExercise: "Select Exercise",
    searchExercises: "Search exercises...",
    recentExercises: "Recent Exercises",
    allExercises: "All Exercises",
    customExercise: "Custom Exercise",
    addCustomExercise: "Add Custom Exercise",
    targetMuscles: "Target Muscles",
    techniqueTips: "Technique Tips",
    commonMistakes: "Common Mistakes",
    history: "History",
    noHistory: "No history available",
    tagFriends: "Tag Friends",
    shareWorkout: "Share Workout",
    copyWorkout: "Copy Workout",
    workoutComplete: "Workout Complete!",
    greatJob: "Great job!",
    summary: "Summary",
    totalVolume: "Total Volume",
    totalSets: "Total Sets",
    totalReps: "Total Reps",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Welcome back",
    todayWorkout: "Today's Workout",
    weeklyProgress: "Weekly Progress",
    recentActivity: "Recent Activity",
    quickActions: "Quick Actions",
    noWorkouts: "No workouts yet",
    startFirst: "Start your first workout!",
    pullToRefresh: "Pull to refresh",
    loadMore: "Load more",
    communityFeed: "Community Feed",
    yourFeed: "Your Feed",
    announcements: "Announcements",
    noActivity: "No recent activity",
    startWorking: "Start working out to see your progress here!",
    streak: "Streak",
    days: "days",
    thisWeek: "This Week",
    personalRecords: "Personal Records",
    weeklyGoal: "Weekly Goal",
    workoutsThisWeek: "workouts this week",
    activity: "Activity",
    upgradeToPremium: "Upgrade to Premium",
    unlockFeatures: "Unlock Stats, Leaderboard & Analytics",
    beFirstToLog: "Be the first to log a workout and share with the community!",
    logFirstWorkout: "Log Your First Workout",
    doLiveWorkout: "Do Live Workout",
    editWorkout: "Edit Workout",
    moreExercises: "more",
    showLess: "Show less",
    aiWorkoutAnalysis: "AI Workout Analysis",
    aiAnalysisDescription: "Get AI-powered insights on performance, form tips, and improvement suggestions. Premium feature.",
    loadingMore: "Loading more workouts...",
    endOfFeed: "You've reached the end of the feed",
    workoutTitle: "Workout Title",
    workoutTitlePlaceholder: "My Awesome Workout",
    descriptionPlaceholder: "Describe your workout...",
    saveChanges: "Save Changes",
    withFriends: "with friends",
  },
  profile: {
    title: "Profile",
    editProfile: "Edit Profile",
    followers: "Followers",
    following: "Following",
    workouts: "Workouts",
    joined: "Joined",
    yourGoals: "Your Goals",
    fitnessGoal: "Fitness Goal",
    experienceLevel: "Experience Level",
    weeklyCheckIn: "Weekly Check-In",
    workoutHistory: "Workout History",
    checkIns: "Check-Ins",
    upgradePremium: "Upgrade to Premium",
    unlockFeatures: "Unlock Stats, Leaderboard & Analytics",
    viewPlans: "View Plans",
    bio: "Bio",
    fullName: "Full Name",
    dateOfBirth: "Date of Birth",
    height: "Height",
    currentWeight: "Current Weight",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    preferNotToSay: "Prefer not to say",
    saveChanges: "Save Changes",
    noGoalsSet: "No goals set yet",
    setGoals: "Set your fitness goals",
    memberSince: "Member since",
    totalWorkouts: "Total Workouts",
    currentStreak: "Current Streak",
    longestStreak: "Longest Streak",
    verified: "Verified",
    statisticsReset: "Statistics Reset",
    statisticsResetDesc: "All your workout data has been deleted successfully.",
    resetFailed: "Failed to reset statistics. Please try again.",
    goalsUpdated: "Goals Updated!",
    goalsUpdatedDesc: "Your fitness goals and experience level have been updated.",
    goals: {
      buildMuscle: "Build Muscle",
      loseWeight: "Lose Weight",
      getStronger: "Get Stronger",
      improveEndurance: "Improve Endurance",
      stayActive: "Stay Active",
      athleticPerformance: "Athletic Performance",
    },
  },
  achievements: {
    title: "Achievements",
    unlocked: "Unlocked",
    locked: "Locked",
    progress: "Progress",
    keepGoing: "Keep going!",
    newUnlock: "New Achievement Unlocked!",
    milestone: "Milestone",
    strength: "Strength",
    consistency: "Consistency",
    social: "Social",
    variety: "Variety",
    volume: "Volume",
    all: "All",
    earned: "Earned",
    unearned: "Not Yet Earned",
    congratulations: "Congratulations!",
    youEarned: "You earned",
    shareAchievement: "Share Achievement",
    viewAll: "View All Achievements",
    recentlyUnlocked: "Recently Unlocked",
  },
  friends: {
    title: "Friends",
    addFriend: "Add Friend",
    searchUsers: "Search users...",
    pending: "Pending",
    accepted: "Friends",
    noFriends: "No friends yet",
    sendRequest: "Send Request",
    acceptRequest: "Accept",
    declineRequest: "Decline",
    removeFriend: "Remove Friend",
    friendRequests: "Friend Requests",
    myFriends: "My Friends",
    suggestions: "Suggestions",
    noRequests: "No pending requests",
    requestSent: "Request sent!",
    requestAccepted: "Request accepted!",
    requestDeclined: "Request declined",
    friendRemoved: "Friend removed",
    mutualFriends: "mutual friends",
    viewProfile: "View Profile",
    message: "Message",
  },
  premium: {
    title: "Premium",
    upgrade: "Upgrade",
    features: "Premium Features",
    monthly: "Monthly",
    yearly: "Yearly",
    currentPlan: "Current Plan",
    subscribe: "Subscribe",
    restore: "Restore Purchases",
    perMonth: "/month",
    perYear: "/year",
    savePercent: "Save",
    mostPopular: "Most Popular",
    freePlan: "Free Plan",
    premiumPlan: "Premium Plan",
    includesFeatures: "Includes all features",
    unlockAll: "Unlock all features",
    alreadyPremium: "You're already a premium member!",
    manageSubscription: "Manage Subscription",
    cancelAnytime: "Cancel anytime",
    startFreeTrial: "Start Free Trial",
    trialDays: "day free trial",
    bestValue: "Best Value",
    billedAnnually: "Billed annually",
    billedMonthly: "Billed monthly",
    featuresList: {
      analytics: "Advanced Analytics & Insights",
      leaderboard: "Fitness Leaderboard Access",
      aiAnalysis: "AI Workout Analysis",
      templates: "Unlimited Templates",
      checkIns: "Weekly Check-ins with Photos",
      exportData: "Export Your Data",
      prioritySupport: "Priority Support",
      noAds: "Ad-free Experience",
    },
  },
  templates: {
    title: "Templates",
    create: "Create Template",
    edit: "Edit Template",
    delete: "Delete Template",
    myTemplates: "My Templates",
    publicTemplates: "Public Templates",
    noTemplates: "No templates yet",
    createFirst: "Create your first template",
    templateName: "Template Name",
    templateDescription: "Description",
    category: "Category",
    makePublic: "Make Public",
    publicDescription: "Allow other premium users to see and use this template",
    addExercise: "Add Exercise",
    saveTemplate: "Save Template",
    useTemplate: "Use Template",
    startWorkout: "Start Workout",
    exercises: "exercises",
    createdBy: "Created by",
    generateWithAI: "Generate with AI",
    aiPromptPlaceholder: "Describe the workout you want (e.g., 'upper body strength workout for beginners')...",
    generating: "Generating...",
    categories: {
      all: "All",
      beginner: "Beginner",
      advanced: "Advanced",
      strength: "Strength",
      hypertrophy: "Hypertrophy",
      endurance: "Endurance",
      general: "General",
    },
  },
  analytics: {
    title: "Analytics",
    overview: "Overview",
    volume: "Volume",
    strength: "Strength",
    progression: "Progression",
    calendar: "Calendar",
    period: "Period",
    week: "Week",
    month: "Month",
    year: "Year",
    totalWorkouts: "Total Workouts",
    totalVolume: "Total Volume",
    avgVolume: "Avg Volume",
    personalRecords: "Personal Records",
    muscleGroups: "Muscle Groups",
    volumeOverTime: "Volume Over Time",
    strengthProgress: "Strength Progress",
    workoutCalendar: "Workout Calendar",
    noData: "No data available",
    startTracking: "Start tracking your workouts to see analytics",
    comparedToPrevious: "compared to previous period",
    improvement: "improvement",
    decline: "decline",
    noChange: "no change",
    exerciseTrends: "Exercise Trends",
    plateauDetection: "Plateau Detection",
    injuryRisk: "Injury Risk Assessment",
    fitnessScore: "Fitness Score",
    restDays: "Rest Days",
    prRate: "PR Rate",
    bestDay: "Best Day",
    volumeVelocity: "Volume Velocity",
    filters: {
      muscleGroup: "Muscle Group",
      exerciseType: "Exercise Type",
      all: "All",
      chest: "Chest",
      back: "Back",
      legs: "Legs",
      shoulders: "Shoulders",
      arms: "Arms",
      cardio: "Cardio",
      strength: "Strength",
    },
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark All Read",
    deleteAll: "Delete All",
    noNotifications: "No notifications yet",
    preferences: "Notification Preferences",
    types: {
      like: "Like",
      comment: "Comment",
      friendRequest: "Friend Request",
      friendAccepted: "Friend Accepted",
      personalRecord: "Personal Record",
      workoutTag: "Workout Tag",
      announcement: "Announcement",
    },
    settings: {
      likes: "Likes",
      likesDescription: "When someone likes your workout",
      comments: "Comments",
      commentsDescription: "When someone comments on your workout",
      friendRequests: "Friend Requests",
      friendRequestsDescription: "When someone sends you a friend request",
      friendAccepted: "Friend Accepted",
      friendAcceptedDescription: "When someone accepts your friend request",
      personalRecords: "Personal Records",
      personalRecordsDescription: "When you achieve a new personal record",
      workoutTags: "Workout Tags",
      workoutTagsDescription: "When someone tags you in a workout",
    },
    deleteAllConfirm: "Delete All Notifications?",
    deleteAllDescription: "This will permanently delete all notifications. This action cannot be undone.",
    allMarkedRead: "All notifications marked as read",
    allDeleted: "All notifications deleted",
  },
  support: {
    title: "Support Center",
    contactUs: "Contact Us",
    contactDescription: "Need help? Our support team is here for you.",
    emailSupport: "Email Support",
    responseTime: "We typically respond within 24 hours",
    submitTicket: "Submit Support Ticket",
    faq: "FAQ",
    frequentlyAsked: "Frequently Asked Questions",
    privacyPolicy: "Privacy Policy",
    privacyDescription: "Learn how we protect and handle your data",
    accountDeletion: "Account Deletion",
    accountDeletionDescription: "Instructions for permanently deleting your account",
    goToSettings: "Go to Settings",
    faqs: {
      cancelSubscription: {
        question: "How do I cancel my subscription?",
        answer: "You can manage your subscription through your account settings. For web subscriptions, use the customer portal. For iOS subscriptions, go to Settings > [Your Name] > Subscriptions on your iPhone.",
      },
      deleteAccount: {
        question: "How do I delete my account?",
        answer: "You can delete your account from the Settings dialog in the app. This will permanently delete all your data including workouts, progress photos, and personal records.",
      },
      dataAfterDeletion: {
        question: "What happens to my data after account deletion?",
        answer: "All your data is permanently deleted from our servers, including workouts, photos, achievements, and personal information. This action cannot be undone.",
      },
      restorePurchase: {
        question: "How do I restore my Apple In-App Purchase?",
        answer: "Go to the Premium page in the app and tap the 'Restore Purchases' button. Make sure you're signed in with the same Apple ID used for the original purchase.",
      },
      exportData: {
        question: "Can I export my workout data?",
        answer: "Premium users can export their workout history from the Analytics page. Free users can contact support for data export requests.",
      },
    },
  },
  leaderboard: {
    title: "Leaderboard",
    rank: "Rank",
    user: "User",
    score: "Score",
    fitnessScore: "Fitness Score",
    weeklyVolume: "Weekly Volume",
    monthlyWorkouts: "Monthly Workouts",
    totalPRs: "Total PRs",
    yourRank: "Your Rank",
    top10: "Top 10",
    friends: "Friends",
    friendsRanking: "Friends Ranking",
    global: "Global",
    globalRanking: "Global Rankings",
    noData: "No leaderboard data available",
    period: "Period",
    metric: "Metric",
  },
  time: {
    justNow: "Just now",
    minutesAgo: "m ago",
    hoursAgo: "h ago",
    daysAgo: "d ago",
    weeksAgo: "w ago",
    monthsAgo: "mo ago",
    yearsAgo: "y ago",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This week",
    lastWeek: "Last week",
    thisMonth: "This month",
    lastMonth: "Last month",
  },
  errors: {
    somethingWentWrong: "Something went wrong",
    tryAgain: "Please try again",
    networkError: "Network error. Please check your connection.",
    notFound: "Not found",
    unauthorized: "You are not authorized to perform this action",
    forbidden: "Access forbidden",
    serverError: "Server error. Please try again later.",
    validationError: "Validation error",
    requiredField: "This field is required",
    invalidEmail: "Please enter a valid email address",
    invalidPassword: "Password does not meet requirements",
    passwordTooShort: "Password must be at least 12 characters",
    usernameTaken: "This username is already taken",
    emailTaken: "This email is already registered",
    invalidCredentials: "Invalid email or password",
    sessionExpired: "Your session has expired. Please sign in again.",
    rateLimited: "Too many attempts. Please try again later.",
    serviceUnavailable: "Service temporarily unavailable. Please try again in a moment.",
  },
  landing: {
    hero: "Track Your Fitness Journey",
    tagline: "The ultimate workout companion for tracking progress, connecting with friends, and achieving your fitness goals.",
    getStarted: "Get Started",
    learnMore: "Learn More",
    features: {
      trackProgress: {
        title: "Track Progress",
        description: "Log workouts, track personal records, and visualize your improvement over time.",
      },
      socialFeed: {
        title: "Social Feed",
        description: "Share achievements, cheer on friends, and stay motivated together.",
      },
      achieveGoals: {
        title: "Achieve Goals",
        description: "Set fitness goals, unlock achievements, and celebrate every milestone.",
      },
    },
  },
};
